import { useEffect } from 'react';
import { SITE_URL, CLINIC } from '../mock';

const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

const upsertMeta = (attr, value, content) => {
  let el = document.head.querySelector(`meta[${attr}="${value}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

/**
 * Lightweight SEO manager: sets <title>, meta description, canonical,
 * Open Graph, Twitter Card, and an optional per-page JSON-LD block.
 */
const Seo = ({ title, description, path = '/', image = DEFAULT_IMAGE, type = 'website', schema }) => {
  const fullTitle = title ? `${title} | ${CLINIC.name}` : `${CLINIC.name} | Virtual Therapy for Mood & Sleep`;
  const url = `${SITE_URL}${path}`;

  useEffect(() => {
    document.title = fullTitle;
    upsertMeta('name', 'description', description);
    upsertLink('canonical', url);

    // Open Graph
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', image);
    upsertMeta('property', 'og:site_name', CLINIC.name);

    // Twitter
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', image);

    // Per-page structured data
    const id = 'route-jsonld';
    let script = document.getElementById(id);
    if (schema) {
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      script.remove();
    }
  }, [fullTitle, description, url, image, type, schema]);

  return null;
};

export default Seo;
